// Rounds a number to 2 decimal places
const roundNumber = (num: number): number => Number(num.toFixed(2));

export default roundNumber;
